import React, { useState, useEffect } from 'react';
import { IconButton } from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import { FormTextField } from "../index";
import { string, func } from "prop-types";

/* withMask HOC adds masking capability to FormTextField.
* Designed to be used with secret policy template where
* fields having names as "l7.secure.*"  needs to be masked.
* */
const withMask = (WrappedComponent) => {
  const withMask = (props) => {
    const { type, handleChange } = props;
    const [mask, setMask] = useState(true);
    const [showIcon, setShowIcon] = useState(false);
    const [isInputFocused, setIsInputFocused] = useState(false);

    useEffect(() => {
      if(isInputFocused) handleChange('');
    },[isInputFocused])

    const renderVisibilityIcon = () => {
      return isInputFocused && showIcon &&
        <IconButton data-apim-test={'visibility-button'} onClick={()=> setMask(!mask)}>
          { mask ? <Visibility/> : <VisibilityOff/> }
        </IconButton>
    }

    const onClickInput = () => {
      setIsInputFocused(true);
      setShowIcon(true);
    }

    return (
      <WrappedComponent
        {...props}
        suffixIcon={renderVisibilityIcon()}
        onClickInput={onClickInput}
        type={mask ? 'password' : type}
      />
    )
  }

  withMask.propTypes = {
    type : string,
    handleChange : func,
  }

  return withMask;
}

const MaskedFormTextField = withMask(FormTextField);
export default MaskedFormTextField;



